import Faqed from "components/UI/Faqed/Faqed";

import "./AmountItem.scss";

const AmountItem = ({ label, value, faq }) => {
  return (
    <div className="amount-item">
      <Faqed text={faq}>
        {label}
        <p>{value?.toLocaleString() ?? ''}</p>
      </Faqed>
    </div>
  );
};

export default AmountItem;
